import { atom } from "jotai";

export const isSavingWizardAtom = atom<boolean>(false);
